import InfoSvg from 'assets/images/info.svg';
import { Wrapper } from './styled';
import ReactTooltip from 'react-tooltip';

const InfoTooltip = ({ key = 'tool', type = 'success' }) => {
  return (
    <>
      <Wrapper data-tip data-for={key}>
        <img alt='info' src={InfoSvg} />
      </Wrapper>
      <ReactTooltip
        backgroundColor='#FF7828'
        id={key}
        place='top'
        effect='solid'
        type={type}
        

      >
        Una volta trascorso il tempo <br /> impostato, dovrai confermare le{' '}
        <br />
        prenotazioni manualmente in <br /> home.
      </ReactTooltip>
    </>
  );
};

export default InfoTooltip;
